import Select from 'react-select';
import { selectStyles } from './selectStyles';

export interface HubspotProperty {
  name: string;
  label: string;
  type: string;
}

/** Property types that can hold the text values matching reads. */
const TEXT_TYPES = ['string', 'text', 'phonenumber'];

interface HubspotPropertyPickerProps {
  label: string;
  hint?: string;
  optional?: boolean;
  value: string;
  onChange: (name: string) => void;
  properties: HubspotProperty[];
  placeholder?: string;
}

/**
 * Picks one of the customer's HubSpot company properties.
 *
 * The internal property name is shown next to the label, because accounts routinely carry
 * several similarly-labelled properties and the internal name is what disambiguates them.
 */
export function HubspotPropertyPicker({
  label,
  hint,
  optional,
  value,
  onChange,
  properties,
  placeholder = 'Select a property',
}: HubspotPropertyPickerProps) {
  const options = properties
    .filter(p => TEXT_TYPES.includes(p.type))
    .map(p => ({ value: p.name, label: p.label, name: p.name }));

  const selectable = optional ? [{ value: '', label: 'None', name: '' }, ...options] : options;

  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ marginBottom: 5 }}>
        {label}
        {optional && <span className="desc-2" style={{ marginLeft: 6 }}>optional</span>}
      </div>
      {hint && <div className="desc-2" style={{ marginBottom: 5 }}>{hint}</div>}
      <div style={{ maxWidth: 460 }}>
        <Select
          options={selectable}
          value={selectable.find(o => o.value === value) ?? null}
          onChange={option => onChange((option as { value: string } | null)?.value ?? '')}
          styles={selectStyles}
          placeholder={placeholder}
          formatOptionLabel={(option: any) => (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>{option.label}</span>
              {option.name && <span className="desc-2" style={{ marginLeft: 12 }}>{option.name}</span>}
            </div>
          )}
        />
      </div>
    </div>
  );
}
